module.exports = __webpack_public_path__ + "static/media/feature-4.51cc6ab7.png";